import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import {
  BookingIntentResponse,
  CheckoutService,
  CheckoutSessionRequest,
  CheckoutSessionResponse,
  CreateProviderAppointmentResponse,
} from '@models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BookingIntentsService
  extends HttpService<BookingIntentResponse>
  implements CheckoutService
{
  createBookingIntent(
    providerId: string,
    appointmentTypeId: string,
    startUtc: string,
    locationType: 'InPerson' | 'Virtual',
    visitLanguage: string,
    landingPageLanguage = 'en'
  ): Observable<BookingIntentResponse> {
    return this.http.post<BookingIntentResponse>(
      `${this.apiRootUrl}/booking-intents`,
      {
        providerId,
        appointmentTypeId,
        startUtc,
        locationType,
        visitLanguage,
        landingPageLanguage,
      }
    );
  }

  createCheckoutSession(request: CheckoutSessionRequest) {
    return this.http.get<CheckoutSessionResponse>(
      `${this.apiRootUrl}/patients/providers/${request.providerId}/booking-intents/${request.itemId}/checkout`
    );
  }

  createSetupSession(request: CheckoutSessionRequest) {
    return this.http.get<{ url: string }>(
      `${this.apiRootUrl}/patients/providers/${request.providerId}/booking-intents/${request.itemId}/setup-payment-method`
    );
  }

  confirmBookingIntent(intentId: string) {
    return this.http.post<CreateProviderAppointmentResponse>(
      `${this.apiRootUrl}/booking-intents/${intentId}/confirm`,
      {}
    );
  }

  cancelBookingIntent(intentId: string): Observable<void> {
    return this.http.post<void>(
      `${this.apiRootUrl}/booking-intents/${intentId}/cancel`,
      {}
    );
  }
}
